import { render, staticRenderFns } from "./HomeTextMessage.vue?vue&type=template&id=467c0eb3&scoped=true&"
import script from "./HomeTextMessage.vue?vue&type=script&lang=js&"
export * from "./HomeTextMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c0eb3",
  null
  
)

export default component.exports